import { render, staticRenderFns } from "./UnknownViewer.vue?vue&type=template&id=20354c3e&"
import script from "./UnknownViewer.vue?vue&type=script&lang=js&"
export * from "./UnknownViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports